/**
 * O que o chip de follow-ups da lista de propostas diz — número e texto andando JUNTOS.
 *
 * (21/09) O chip mostrava sempre a quantidade EM ABERTO e, quando não havia próximo, o
 * texto «concluído(s)». Com um follow-up registrado como feito (e nenhum em aberto), saía
 * «0 concluído(s)» em cima de uma lista com um concluído — o número era de um contador e
 * a palavra, de outro. Aqui cada caso escolhe o número que a palavra descreve.
 *
 * @param {{ abertos: number, concluidos: number }} p
 * @returns {{ numero: number, texto: string|null }} `texto: null` = mostrar a data do
 *   próximo follow-up em aberto (quem formata a data é a tela)
 */
export function contadorDeFollowups({ abertos, concluidos }) {
  const a = Math.max(0, Number(abertos) || 0);
  const c = Math.max(0, Number(concluidos) || 0);
  if (a > 0) return { numero: a, texto: null };
  return { numero: c, texto: c === 1 ? 'concluído' : 'concluídos' };
}
